const filtrosTender = {
  condicionesPago: [
    { value: "Pago adelantado", label: "Por adelantado" },
    { value: "Contraentrega", label: "Contraentrega" },
    { value: "Crédito a 15 días", label: "Crédito a 15 días" },
    { value: "Crédito a 30 días", label: "Crédito a 30 días" },
    { value: "Crédito a 60 días", label: "Crédito a 60 días" },
    { value: "Crédito a 90 días", label: "Crédito a 90 días" },
    { value: "Crédito mayor a 90 días", label: "Crédito mayor a 90 días" },
  ],
  duracionContrato: [
    { value: "Sin contrato", label: "Sin contrato" },
    { value: "Mensual", label: "Mensual" },
    { value: "Trimestral", label: "Trimestral" },
    { value: "Semestral", label: "Semestral" },
    { value: "Anual", label: "Anual" },
    { value: "Por proyecto", label: "Por proyecto" },
    { value: "Indefinido", label: "Indefinido" },
  ],
  fechas: [
    { value: "last_month", label: "Mes pasado" },
    { value: "last_week", label: "Semana pasada" },
    { value: "last_24_hours", label: "Últimas 24 horas" },
  ],
};

export default filtrosTender;
